import { jsxs as f, jsx as l } from "react/jsx-runtime";
import { E as g, S as p } from "./icons.types-0722eef5.js";
function v({ title: o, titleId: c, size: r, width: s, height: t, extended: n = !1, ...a }) {
  const i = n ? g : p, h = r ? i[r] : s || i[n ? "s" : "l"], e = r ? i[r] : t || i[n ? "s" : "l"];
  return /* @__PURE__ */ f(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      width: h,
      height: e,
      "aria-labelledby": c,
      ...a,
      children: [
        o ? /* @__PURE__ */ l("title", { id: c, children: o }) : null,
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentcolor",
            d: "M12 1a2 2 0 0 1 1.752 1.036l10 18.182A2 2 0 0 1 22 23.182H2a2 2 0 0 1-1.752-2.964l10-18.182A2 2 0 0 1 12 1M3.1 19.182l-1.1 2h20l-1.1-2-7.759-14.107L12 3l-1.141 2.075z"
          }
        ),
        /* @__PURE__ */ l("path", { d: "M2 21.182 12 3l10 18.182z" }),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "currentcolor",
            d: "M12.6 15.438c.133-1.575.467-5.972.467-7.22v-.655h-2v.656c0 1.247.266 5.644.466 7.219z"
          }
        ),
        /* @__PURE__ */ l(
          "ellipse",
          {
            cx: 12,
            cy: 18.063,
            fill: "currentcolor",
            rx: 1.333,
            ry: 1.313
          }
        )
      ]
    }
  );
}
export {
  v as Warning
};
